
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class LotCreationBOMGrid extends Serenity.EntityGrid<LotCreationBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.LotCreationBOM'; }
        protected getDialogType() { return LotCreationBOMDialog; }
        protected getIdProperty() { return LotCreationBOMRow.idProperty; }
        protected getInsertPermission() { return LotCreationBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return LotCreationBOMRow.localTextPrefix; }
        protected getService() { return LotCreationBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}